<template>
  <!-- 雇主险保费管理 -->
  <div>
    <div v-show="gzxbfgl">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险保费管理</div>
      <!-- 主体 -->
      <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
        <!-- 查询框 -->
        <div style="margin-left:3%">
          <div style="height:10px"></div>
          <div style="display:inline-block;margin-top:20px">
            <span>组织架构</span>
            <el-cascader v-model="condition.organize_ids" clearable
                style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
          </div>

          <div style="display:inline-block;margin-top:20px;margin-left:20px">
            <span>岗位 </span>
            <el-select v-model="condition.post_id" style="margin-left:10px;width:150px" placeholder="请选择" clearable>
                <el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
                </el-option>
            </el-select>
          </div>

          <div style="display:inline-block;margin-top:20px;margin-left:20px">
            <span>性别 </span>
            <el-select v-model="condition.spare5" placeholder="请选择性别" style="margin-left:10px;width:150px" clearable>
              <el-option v-for="item in spare" :key="item.value" :label="item.data"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <!-- 按钮 -->
          <div style="display:inline-block;margin:20px 50px;float:right">
            <el-button type="goon" @click="Find">查询</el-button>
            <el-button type="goon" @click="Del(null)">删除</el-button>
            <el-button type="addbtn" @click="add">新增</el-button>
          </div>
        </div>

        <!-- 表格 -->
        <div style="margin:2% 3% 0 3%">
          <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" :row-class-name="tableRowClassName"
            ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" height="540"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column align="center" label="序号" width="60">
              <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
            </el-table-column>
            <el-table-column align="center" label="组织架构" width="300">
				<template slot-scope="scope">
					{{$globals.group_name + "/" + scope.row.organize_name}}
				</template>
			</el-table-column>
            <el-table-column prop="post_name" align="center" label="岗位"></el-table-column>
            <el-table-column prop="insurance_price" align="center" label="保费金额"></el-table-column>
            <el-table-column prop="age" align="center" label="年龄"></el-table-column>
            <el-table-column prop="spare5" align="center" label="性别">
              <template slot-scope="scope">
                <span v-show="scope.row.spare5 === '2'" >不限</span>
                <span v-show="scope.row.spare5 === '1'" >男</span>
                <span v-show="scope.row.spare5 === '0'" >女</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <!-- <img src="../../../assets/编辑.png" @click="bianji(scope.row)"> -->
                <img src="../../../assets/删除.png" @click="Del(scope.row.id)">
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-row style="margin-top: 10px; text-align: center;">
            <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
              layout=" prev, pager, next, jumper" :total="total">

            </el-pagination>
          </el-row>
        </div>

      </div>
    </div>
    
    <!-- 新增 -->
    <el-dialog :title="ruleForm.id == null || ruleForm.id == '' ? '添加用户' : '修改用户'" :visible.sync="dialogVisible"
        width="30%" :close-on-click-modal="false" :center="true">
        <add ref="add"></add>
    </el-dialog>
  </div>
</template>

<script>
import add from './gzxbfgl_add.vue';
import axios from 'axios';
export default {
  components: {
    add: add,
  },
  data() {
		var organizeFind = async (e, spare8) => {
			var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
				identification: "1",
				organize_id: e,
				spare8: spare8,
			});
            return organizeList.data;
        };
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      tableData: [],
      staffList: [],
      dialogVisible: false,
      ruleForm: {
        id:"",
        post_id:'',
        organize_name:'',
        insurance_price:'',
        age:'',
        organize_ids: [],
        postId:[],
        spare5:'',
      },
      //职位数据
	    postList: [],
      // 权限
      gzxbfgl: true,
      showadd: false,
      ids: [],
      //条件
      condition: {
        id:'',
		    organize_ids: [],
        post_id:'',
        age:'',
        spare5:'',
      },

      spare:[
				{
					data:'不限',
					value:2
				},
				{
					data:'男',
					value:1
				},
				{
					data:'女',
					value:0
				},
			],
	  
	  //组织架构数据
    organizeList: [],
    //年龄范围数据
		ageList: [],
	  
	  //级联下拉配置
	  props: {
			lazy: true,
			async lazyLoad(node, resolve) {
				if (node.level === 0) {
					return resolve(await organizeFind('', 'group'));
				} else {
					resolve(await organizeFind(node.data.id, ''));
				}
			},
	      value: "id",
	      label: "organize_name",
	      children: "organizeList",
	      checkStrictly: true,
	      multiple: true,
	  },
    };
  },
  methods: {
    // 全选
    handleSelectionChange(e) {
        this.ids = [];
        e.forEach(item => {
        this.ids.push(item.id);
      });
    },
    // 新增
    add(){
      this.trash();
	    this.dialogVisible = true;
    },
    // 操作编辑
    bianji(e) {
      this.trash();
      this.dialogVisible = true;
      this.ruleForm.id = e.id;
      this.ruleForm.post_id = e.post_id;
      this.ruleForm.organize_name = e.organize_name;
      this.ruleForm.insurance_price = e.insurance_price;
      this.ruleForm.iorganize_idsd = e.organize_ids;
      this.ruleForm.age = e.age;
    },
    //查询
    async Find() {
      var temporary = [];
      this.condition.organize_ids.forEach(item => {
          temporary.push(item[item.length - 1]);
      })
      var organize_ids = "";
      temporary.forEach(item => {
          organize_ids += item + ",";
      })
      
      var url = 'PremiumTable/selectAll';
      var record = {
        page_num: this.page_num,
        page_size: this.page_size,
        organize_ids: organize_ids,
        post_id: this.condition.post_id,
        age:this.condition.age,
        spare5:this.condition.spare5,
      };
      var data = await this.$globals.AxiosPost(url, record);
      if (data === '-2000') {
        this.$message.error('服务器未响应！请稍后重试');
      } else {
        var code = data.code;
        var data = data.data;
        if (code === '200') {
          this.tableData = data;
          this.total = data.total;
        } else {
          this.$message.warning('请求失败！请稍后重试');
        }
      }
    },
    // 操作删除
    async Del(e) {
        var ids;
        if (e === null || e === "" || e === undefined) {
            if (this.ids === null || this.ids.length <= 0) {
                this.$message.warning("请先选择操作数据！");
                return false;
            }
            ids = this.ids;
        } else {
            ids = [e];
        }
        
        var url = "PremiumTable/del";
        var record = {
            ids: ids,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.trash();
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    
    //分页
    handleCurrentChange(val) {
      this.page_num = val;
      this.Find();
    },
    //清除数据
			trash() {
        this.ruleForm.id = '';
        this.condition.id = '';
				this.ruleForm.organize_ids = [];
				this.ruleForm.organize_ids = '';
				this.ruleForm.post_id = '';
        this.ruleForm.insurance_price = '';
        this.ruleForm.age = '';
        this.ruleForm.spare5 = '';
        this.ruleForm.postId = [];
			},
    //返回
    Return() {
        this.dialogVisible = false;
        this.Find();
    },
  },
  async created() {
    this.Find();
    // 职位数据
    var postList = await this.$globals.AxiosPost('post/selectFind', {});
    this.postList = postList.data;
    // 年龄段类型
    var ageList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
      data_grouping: "age_group"
    });
    this.ageList = ageList.data;
  },
};
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006e4b;
  border-color: #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color: #05573d;
  color: #006e4b;
}
.el-button--goon {
  color: #fff;
  background-color: #006e4b;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color: #006e4b;
  background-color: #fff;
  border-color: #006e4b;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #006e4b;
  border-color: #006e4b;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #006e4b;
}
.el-checkbox__inner:hover {
  border-color: #006e4b;
}
.el-button--pic {
  color: #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 10px;
  height:30px;
  width: 70px;
  padding: 10px;
}
.el-button--pic:focus,
.el-button--pic:hover {
  background: #fff;
  border-color:  #05573d;
  color: #006E4B;
}
</style>


// WEBPACK FOOTER //
// Gzxbfgl.vue?06cac4a4